import { Home as NewHomePage } from "@redotech/redo-customer-portal-app/faq/home";
import { memo } from "react";

export const Home = memo(function Home() {
  return <NewHomePage />;
});
